import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listAvailableOcrProviders, SchemaQueryKeys, type TenantOcrProviderResponse } from '../api';

/**
 * Lists the platform OCR providers the tenant's license grants access to. Returns an empty array when
 * the plan has no OCR providers assigned — in that case the editor only offers the Azure Document
 * Intelligence default.
 */
export function useTenantOcrProviders(): UseQueryResult<TenantOcrProviderResponse[]> {
  return useQuery({
    queryKey: SchemaQueryKeys.ocrProviders,
    queryFn: ({ signal }) => listAvailableOcrProviders(signal),
  });
}
